import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "skill-details" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"mb-10\"><nav class=\"flex space-x-4\" aria-label=\"Tabs\"><div class=\"text-neutral-500 hover:text-neutral-700 px-3 py-2 font-semibold text-sm rounded-md bg-sienna-100 text-neutral-700 cursor-pointer\"> Vận động thô </div><div class=\"text-neutral-500 hover:text-neutral-700 px-3 py-2 font-medium text-sm rounded-md cursor-pointer\"> Vận động tinh </div><div class=\"text-neutral-500 hover:text-neutral-700 px-3 py-2 font-medium text-sm rounded-md cursor-pointer\"> Giao tiếp </div><div class=\"text-neutral-500 hover:text-neutral-700 px-3 py-2 font-medium text-sm rounded-md cursor-pointer\"> Toán </div><div class=\"text-neutral-500 hover:text-neutral-700 px-3 py-2 font-medium text-sm rounded-md cursor-pointer\"> Viết </div><div class=\"text-neutral-500 hover:text-neutral-700 px-3 py-2 font-medium text-sm rounded-md cursor-pointer\"> Đọc </div><div class=\"text-neutral-500 hover:text-neutral-700 px-3 py-2 font-medium text-sm rounded-md cursor-pointer\"> Hành vi &amp; Giác quans </div></nav></div>", 1)
const _hoisted_3 = { class: "p-6 bg-white shadow-sm rounded-2xl mb-10" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "font-semibold text-neutral-600 mb-6" }, "Vận động thô", -1)
const _hoisted_5 = { class: "flex flex-nowrap" }
const _hoisted_6 = { class: "p-6 border rounded-l-lg border-neutral-200 w-full" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "text-33 font-bold text-neutral-600 mb-6" }, "3", -1)
const _hoisted_8 = { class: "flex flex-nowrap items-center" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "text-neutral-500 text-sm" }, "Tổng số mục tiêu trong tháng này", -1)
const _hoisted_10 = { class: "p-6 border border-neutral-200 border-l-0 border-r-0 w-full" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "text-33 font-bold text-neutral-600 mb-6" }, "1", -1)
const _hoisted_12 = { class: "flex flex-nowrap items-center" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "text-neutral-500 text-sm" }, "Mục tiêu lặp lại", -1)
const _hoisted_14 = { class: "p-6 border rounded-r-lg border-neutral-200 w-full" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "text-33 font-bold text-sienna-400 mb-6" }, "2", -1)
const _hoisted_16 = { class: "flex flex-nowrap items-center" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "text-neutral-500 text-sm" }, "Mục tiêu mới ", -1)
const _hoisted_18 = { class: "shadow-sm sm:rounded-2xl mt-10 overflow-hidden" }
const _hoisted_19 = { class: "__record__table overflow-x-auto scroll-bar" }
const _hoisted_20 = { class: "overflow-hidden sm:rounded-t-2xl w-fit min-w-full" }
const _hoisted_21 = { class: "min-w-full divide-y text-neutral-200" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("thead", { class: "bg-neutral-100 h-16" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-6 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider w-16 whitespace-nowrap"
    }, " STT "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-6 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
    }, " Loại "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-6 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
    }, " Nội dung "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-6 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
    }, " 3 buổi gần nhất "),
    /*#__PURE__*/_createElementVNode("th", { class: "w-32" })
  ])
], -1)
const _hoisted_23 = { class: "px-6 py-4 whitespace-nowrap text-neutral-700" }
const _hoisted_24 = { class: "px-6 py-4 whitespace-nowrap text-neutral-700 flex items-center" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", {
  class: "h-5 w-5 rounded-full ml-3",
  style: {"background":"#eacece"}
}, null, -1)
const _hoisted_26 = { class: "px-6 py-4 whitespace-nowrap text-neutral-700" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("td", { class: "px-6 py-4 whitespace-nowrap text-neutral-700" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("span", {
      class: "inline-flex items-center px-3 py-0.5 rounded-full text-sm font-semibold text-white mr-4",
      style: {"background":"#2aa797"}
    }, " > 75% "),
    /*#__PURE__*/_createElementVNode("span", {
      class: "inline-flex items-center px-3 py-0.5 rounded-full text-sm font-semibold text-white mr-4",
      style: {"background":"#2aa797"}
    }, " > 75% "),
    /*#__PURE__*/_createElementVNode("span", {
      class: "inline-flex items-center px-3 py-0.5 rounded-full text-sm font-semibold text-white",
      style: {"background":"#2aa797"}
    }, " > 75% ")
  ])
], -1)
const _hoisted_28 = { class: "flex flex-nowrap items-center" }
const _hoisted_29 = { class: "p-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DaIcon = _resolveComponent("DaIcon")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_DaIcon, {
              name: "das--goal",
              class: "h-4 w-4 text-yellow-600 mr-2"
            }),
            _hoisted_9
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_DaIcon, {
              name: "das--goal",
              class: "h-4 w-4 text-yellow-600 mr-2"
            }),
            _hoisted_13
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _hoisted_15,
          _createElementVNode("div", _hoisted_16, [
            _createVNode(_component_DaIcon, {
              name: "das--goal",
              class: "h-4 w-4 text-yellow-600 mr-2"
            }),
            _hoisted_17
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_18, [
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("table", _hoisted_21, [
            _hoisted_22,
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.people, (person, personIdx) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: person.id,
                  class: _normalizeClass([
									personIdx % 2 === 0
										? 'bg-white'
										: 'bg-neutral-50'
								, "text-neutral-700"])
                }, [
                  _createElementVNode("td", _hoisted_23, [
                    _createElementVNode("div", null, _toDisplayString(person.id), 1)
                  ]),
                  _createElementVNode("td", _hoisted_24, [
                    _createElementVNode("div", null, _toDisplayString(person.type), 1),
                    _hoisted_25
                  ]),
                  _createElementVNode("td", _hoisted_26, [
                    _createElementVNode("div", null, _toDisplayString(person.content), 1)
                  ]),
                  _hoisted_27,
                  _createElementVNode("td", null, [
                    _createElementVNode("div", _hoisted_28, [
                      _createElementVNode("div", _hoisted_29, [
                        _createVNode(_component_router_link, { to: "/goal-management/1/skill-details/2" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_DaIcon, {
                              name: "das--chevron-down",
                              class: "h-4 w-4 text-blue-600 hover:text-blue-900 active:text-blue-500 cursor-pointer transform -rotate-90"
                            })
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ])
                ], 2))
              }), 128))
            ])
          ])
        ])
      ])
    ])
  ]))
}